export default __webpack_public_path__ + "static/media/gri-emerald.7b0ba51c.jpg";